module.exports = __webpack_public_path__ + "static/media/belt-default.707b689a.png";